import * as turf from '@turf/turf'
import { message } from 'antd'
import { FeatureCollection, Point } from 'geojson'
import { useEffect, useState } from 'react'

import { PROPERTY_TYPES } from '../../../../common/drmTypes'
import { setCadastralFilter } from '../../../../redux/cadastralFilterSlice'
import { useAppDispatch } from '../../../../redux/hooks'
import { RuianQuery, RuianQueryInputGeometry } from '../util/RuianQuery'

export function useParcelPoints(
  where: string,
  shouldFetch: boolean,
  geometryFilter?: RuianQueryInputGeometry | null
): [boolean, FeatureCollection<Point>] {
  const [loading, setLoading] = useState(false)
  const [parcels, setParcels] = useState(turf.featureCollection<Point>([]))
  const dispatch = useAppDispatch()

  useEffect(() => {
    fetchParcelPoints()
    async function fetchParcelPoints() {
      try {
        setLoading(true)
        if (!shouldFetch) return
        if (!where || where === '') {
          setParcels(turf.featureCollection([]))
          return
        }
        let query = RuianQuery.ParcelaDefinicniBod.outFields([
          'objectid',
        ]).where(where)

        if (geometryFilter) {
          query = query.layerInputGeometry(geometryFilter)
        }

        const params = await query.getFinalSearchParamsForRequest()
        const geojson = await query.asGeoJson()

        setParcels(geojson)

        dispatch(
          setCadastralFilter({
            whereClause: JSON.stringify(Object.fromEntries(params.entries())),
            count: geojson?.features?.length || 0,
            propertyType: PROPERTY_TYPES.AREA,
          })
        )
      } catch (error) {
        console.error(error)
        message.error('Nepodařilo se načíst parcelní body')
        setParcels(turf.featureCollection([]))
      } finally {
        setLoading(false)
      }
    }
    // Not really sure, but if I pass shouldFetch and even if I exit early it causes expensive re-fetch
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [where, geometryFilter])

  return [loading, parcels]
}
